import { useTranslation } from "react-i18next";

export default function FpTracker({ current, refresh }: { current: number; refresh: number }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2 rounded border border-border bg-card px-2 py-1 text-sm">
      <span className="text-muted-foreground">{t("sheet.fp")}</span>
      <span className="font-mono">
        {current} / {refresh}
      </span>
    </div>
  );
}
